import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';

/**
 * The list of tabs on this page
 */
export enum DeliveryEventsPageTabId {
	Events = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum DeliveryEventsPageViewId {
	UpcomingEvents = 1,
	PastEvents = 2,
}


@Injectable({ providedIn: 'root' })
export class DeliveryEventsService extends PageTabsLayoutPageService<DeliveryEventsPageTabId, DeliveryEventsPageViewId> {
	private static readonly _viewDroplistItems: DroplistItem<never, DeliveryEventsPageViewId>[] = [
		{
			uniqueId: DeliveryEventsPageViewId.UpcomingEvents,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Upcoming Events',
				hideText: 'never',
			}
		},
		{
			uniqueId: DeliveryEventsPageViewId.PastEvents,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Past Events',
				hideText: 'never',
			}
		},

	];
	constructor() {
		super(DeliveryEventsService._viewDroplistItems, DeliveryEventsService.name, DeliveryEventsPageTabId.Events, DeliveryEventsPageViewId.UpcomingEvents);
	}

	public get viewId() {
		return DeliveryEventsPageViewId;
	}

}